/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */
import {
	ACTION_MENU_ITEM,
	AI_IMAGE_GENERATION_MENU_ITEM,
	ASK_ROVO_MENU_ITEM,
	ASSETS_MENU_ITEM,
	BLOCKQUOTE_MENU_ITEM,
	BLOCK_TEMPLATES_SECTION,
	CODE_BLOCK_MENU_ITEM,
	CUSTOM_PANEL_MENU_ITEM,
	DATE_MENU_ITEM,
	DATA_AND_CHARTS_SECTION,
	DECISION_MENU_ITEM,
	EMBED_SECTION,
	EMOJI_MENU_ITEM,
	ERROR_PANEL_MENU_ITEM,
	EXPAND_MENU_ITEM,
	FIVE_COLUMNS_LAYOUT_MENU_ITEM,
	FOUR_COLUMNS_LAYOUT_MENU_ITEM,
	HEADING_1_MENU_ITEM,
	HEADING_2_MENU_ITEM,
	HEADING_3_MENU_ITEM,
	HEADING_4_MENU_ITEM,
	HEADING_5_MENU_ITEM,
	HEADING_6_MENU_ITEM,
	HELP_DIALOG_MENU_ITEM,
	HYPERLINK_MENU_ITEM,
	INFO_PANEL_MENU_ITEM,
	JIRA_WORK_ITEMS_MENU_ITEM,
	LOOM_MENU_ITEM,
	MEDIA_INSERT_MENU_ITEM,
	MEDIA_SECTION,
	MENTION_MENU_ITEM,
	NOTE_PANEL_MENU_ITEM,
	ORDERED_LIST_MENU_ITEM,
	OTHER_SECTION,
	PLACEHOLDER_TEXT_MENU_ITEM,
	RECOMMENDED_SECTION,
	ROVO_SECTION,
	RULE_MENU_ITEM,
	STATUS_MENU_ITEM,
	STRUCTURE_SECTION,
	SUCCESS_PANEL_MENU_ITEM,
	SYNCED_BLOCK_MENU_ITEM,
	TABLE_MENU_ITEM,
	TEXT_FORMATTING_SECTION,
	THREE_COLUMNS_LAYOUT_MENU_ITEM,
	TWO_COLUMNS_LAYOUT_MENU_ITEM,
	UNORDERED_LIST_MENU_ITEM,
	WARNING_PANEL_MENU_ITEM,
} from './keys';

export const QUICK_INSERT_MENU_RANK: Readonly<Record<string, number>> = {
	[RECOMMENDED_SECTION.key]: 0,
	[STRUCTURE_SECTION.key]: 1,
	[MEDIA_SECTION.key]: 2,
	[EMBED_SECTION.key]: 3,
	[TEXT_FORMATTING_SECTION.key]: 4,
	[ROVO_SECTION.key]: 5,
	[DATA_AND_CHARTS_SECTION.key]: 6,
	[BLOCK_TEMPLATES_SECTION.key]: 7,
	[OTHER_SECTION.key]: 8,
} as const;

export const STRUCTURE_SECTION_RANK: Readonly<Record<string, number>> = {
	[ACTION_MENU_ITEM.key]: 100,
	[TABLE_MENU_ITEM.key]: 200,
	[STATUS_MENU_ITEM.key]: 300,
	[DATE_MENU_ITEM.key]: 400,
	[EXPAND_MENU_ITEM.key]: 700,
	[CODE_BLOCK_MENU_ITEM.key]: 800,
	[INFO_PANEL_MENU_ITEM.key]: 900,
	[NOTE_PANEL_MENU_ITEM.key]: 1000,
	[SUCCESS_PANEL_MENU_ITEM.key]: 1100,
	[WARNING_PANEL_MENU_ITEM.key]: 1200,
	[ERROR_PANEL_MENU_ITEM.key]: 1300,
	[CUSTOM_PANEL_MENU_ITEM.key]: 1400,
	[TWO_COLUMNS_LAYOUT_MENU_ITEM.key]: 1500,
	[THREE_COLUMNS_LAYOUT_MENU_ITEM.key]: 1600,
	[FOUR_COLUMNS_LAYOUT_MENU_ITEM.key]: 1700,
	[FIVE_COLUMNS_LAYOUT_MENU_ITEM.key]: 1800,
	[SYNCED_BLOCK_MENU_ITEM.key]: 2300,
	[RULE_MENU_ITEM.key]: 2400,
	[DECISION_MENU_ITEM.key]: 2800,
} as const;

export const MEDIA_SECTION_RANK: Readonly<Record<string, number>> = {
	[MEDIA_INSERT_MENU_ITEM.key]: 100,
	[HYPERLINK_MENU_ITEM.key]: 200,
	[EMOJI_MENU_ITEM.key]: 300,
	[LOOM_MENU_ITEM.key]: 400,
	[MENTION_MENU_ITEM.key]: 1500,
	[AI_IMAGE_GENERATION_MENU_ITEM.key]: 1600,
} as const;

export const TEXT_FORMATTING_SECTION_RANK: Readonly<Record<string, number>> = {
	[HEADING_1_MENU_ITEM.key]: 100,
	[HEADING_2_MENU_ITEM.key]: 200,
	[HEADING_3_MENU_ITEM.key]: 300,
	[HEADING_4_MENU_ITEM.key]: 400,
	[HEADING_5_MENU_ITEM.key]: 500,
	[HEADING_6_MENU_ITEM.key]: 600,
	[BLOCKQUOTE_MENU_ITEM.key]: 700,
	[PLACEHOLDER_TEXT_MENU_ITEM.key]: 900,
	[UNORDERED_LIST_MENU_ITEM.key]: 1100,
	[ORDERED_LIST_MENU_ITEM.key]: 1200,
} as const;

export const ROVO_SECTION_RANK: Readonly<Record<string, number>> = {
	[ASK_ROVO_MENU_ITEM.key]: 100,
} as const;

export const DATA_AND_CHARTS_SECTION_RANK: Readonly<Record<string, number>> = {
	[JIRA_WORK_ITEMS_MENU_ITEM.key]: 300,
	[ASSETS_MENU_ITEM.key]: 500,
} as const;

export const OTHER_SECTION_RANK: Readonly<Record<string, number>> = {
	[HELP_DIALOG_MENU_ITEM.key]: 100,
} as const;

export const EXTENSION_ITEM_RANK = 1500;
export const CATEGORY_VIEW_MORE_RANK: number = Number.MAX_SAFE_INTEGER;
